import { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from 'utils/yup';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { UserRegisterRepository } from 'interfaceAdapter/repositories/UserRegister';
import { SupportUserTokenRepository } from 'interfaceAdapter/repositories/SupportUserToken';
import { useParams } from 'react-router-dom';
import { useLoading } from 'application/contexts/useLoading';

const schema = yup
    .object({
        password: yup
            .string()
            .required()
            .min(8)
            .max(100)
            .matches(
                /^(?=.*?[a-z])(?=.*?\d)[a-z\d!@#$%^&*()_+{}":?><,./;'[\]\\\-]{8,100}$/i,
                '半角英数字を含めて入力してください',
            ),
    })
    .required();

type PasswordForm = yup.InferType<typeof schema>;

export const useSupporterPasswordRegistration = () => {
    const diContainer = useContext(diContainerContext);
    const userRegisterRepository = diContainer.resolve(UserRegisterRepository);
    const supportUserTokenRepository = diContainer.resolve(SupportUserTokenRepository);
    const { loading, setLoading } = useLoading();
    const [complete, setComplete] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [urlId, setUrlId] = useState('');
    const params = useParams();

    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
    } = useForm<PasswordForm>({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            password: '',
        },
    });

    useEffect(() => {
        if (!params.url_id) {
            return;
        }
        setUrlId(params.url_id);
    }, [params.url_id]);

    const send = handleSubmit(async ({ password }) => {
        setLoading(true);
        try {
            const data = await userRegisterRepository.supporterRegistrationPassword(urlId, password);
            supportUserTokenRepository.set(data.api_token);
            setComplete(true);
            setShowSnackbar(true);
            setTimeout(() => window.location.replace(`/supporter/registration/user_profile/`), 1500);
        } finally {
            setLoading(false);
        }
    });

    return {
        control,
        errors,
        loading,
        complete,
        showSnackbar,
        setShowSnackbar,
        send,
        getValues,
    };
};
